export const BUMPER_AI_COLOR = '#FF4722'; //TODO: We need to add this color to our theme file
export const QUESTIONS_PER_PAGE = 5;
export const ANSWERS_PER_PAGE_ON_DESKTOP = 4;
export const ANSWERS_PER_PAGE_ON_MOBILE = 5;
export const BUMPER_AI_USERNAME = 'Bumper AI';

export const SOCIAL_SENTIMENT_GA4_EVENTS = {
  socialSentimentViewSentimentAction: {
    name: 'cta_click',
    type: 'view social sentiment',
  },
  socialSentimentAddCommentAction: {
    name: 'cta_click',
    type: 'add social sentiment comment',
  },
  socialSentimentClickUrlAction: {
    name: 'cta_click',
    type: 'click social sentiment url',
  },
};
